import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import Home from '~/pages/Home';
import Checklist from '~/pages/Checklist';
import Projects from '~/pages/Projects';
import About from '~/pages/About';
import Equipments from '~/pages/Equipments';
import Proposal from '~/pages/Proposal';
import Login from '~/pages/Login';
import AuthRedirect from '~/pages/AuthRedirect';
import Comparison from '~/pages/Comparison';
import Compressores from '~/pages/Compressores';
import GuestCompressorAccess from '~/pages/GuestCompressorAccess/GuestCompressorAccess';
import GuestUsers from '~/pages/GuestUsers';
import CondensadorRemoto from '~/pages/CondensadorRemoto';
import { RouteWrapper } from './Route';

export default function Routes() {
  return (
    <>
      <Switch>
        <Redirect exact from="/" to="/projects" />

        <RouteWrapper path="/guest/compressores/:productType" component={GuestCompressorAccess} pageTitle="Compressor" />

        {/* Project */}
        <RouteWrapper
          path="/projects/calculo-camaras-frias/:id/rooms"
          component={Checklist}
          pageTitle="Cálculo de Carga Térmica"
          isPrivate
          isRefreshState
        />
        <RouteWrapper
          path="/projects/calculo-camaras-frias/:id/equipments"
          component={Equipments}
          pageTitle="Seleção de Equipamentos"
          isPrivate
        />
        <RouteWrapper
          path="/projects/calculo-camaras-frias/:id/proposal"
          component={Proposal}
          pageTitle="Resultado da Seleção"
          isPrivate
        />
        <RouteWrapper path="/projects/evaporadores" component={Comparison} pageTitle="Evaporadores" isPrivate />
        <RouteWrapper
          path="/projects/unidades-condensadoras"
          component={Comparison}
          pageTitle="Unidades Condensadoras"
          isPrivate
        />
        <RouteWrapper
          path="/projects/compressores-hermetico/:id"
          component={Compressores}
          pageTitle="Compressor Hermético"
          isPrivate
        />
        <RouteWrapper
          path="/projects/compressores/:id"
          component={Compressores}
          pageTitle="Compressor Semi-Hermético"
          isPrivate
        />
        {/* <RouteWrapper
          path="/projects/condensador-remoto/:id"
          component={CondensadorRemoto}
          pageTitle="Condensador Remoto"
          isPrivate
        /> */}
        <RouteWrapper path="/projects/evaporadores/:id" component={Comparison} pageTitle="Evaporadores" isPrivate />
        <RouteWrapper
          path="/projects/unidades-condensadoras/:id"
          component={Comparison}
          pageTitle="Unidades Condensadoras"
          isPrivate
        />
        <RouteWrapper path="/projects" component={Projects} pageTitle="Projetos" isPrivate />
        <RouteWrapper path="/comparison" component={Comparison} pageTitle="Comparar Produtos" isPrivate />
        <RouteWrapper path="/guest-users" component={GuestUsers} pageTitle="Usuários Guest" isPrivate />

        {/* Auth */}
        <RouteWrapper path="/auth/callback" component={Login} />
        {/* Login por token ou por authorization code */}
        <RouteWrapper path="/login" component={Login} />
        <RouteWrapper path="/logout" component={AuthRedirect} isLogin={false} />

        {/* Other */}
        <RouteWrapper path="/about" component={About} pageTitle="Sobre" isPrivate />
      </Switch>
    </>
  );
}
